module.exports = __webpack_public_path__ + "img/group-reg.635e7cef.svg";